import { parseUnits } from '@train-protocol/sdk';
import { dataBytes, identityFromAddress, optionalContractId, optionalDataBytes, unixSecondsToTai64, } from '../../utils.js';
import { buildContract } from '../helpers.js';
export async function buildUserLockArguments(signer, params) {
    if (!params.atomicContract)
        throw new Error('No contract address');
    if (!params.srcSolverAddress)
        throw new Error('No solver address');
    if (params.nonce == null)
        throw new Error('No nonce');
    const amount = parseUnits(params.amount, params.sourceAsset.decimals);
    const assetId = params.sourceAsset.contract
        ? params.sourceAsset.contract
        : await signer.account.provider.getBaseAssetId();
    const lock = {
        hashlock: params.hashlock,
        timelock_delta: params.timelockDelta,
        quote_expiry: unixSecondsToTai64(params.quoteExpiry),
        recipient: identityFromAddress(params.srcSolverAddress),
        refund_to: identityFromAddress(params.sourceAddress),
        payout_curve: optionalContractId(params.payoutCurve),
        payout_curve_data: optionalDataBytes(params.payoutCurveData),
        reward_amount: params.rewardAmount ?? '0',
        reward_timelock_delta: params.rewardTimelockDelta ?? 0,
        reward_token: params.rewardToken ?? '',
        reward_recipient: params.rewardRecipient ?? '',
        src_chain: params.sourceChain,
    };
    const destination = {
        dst_chain: params.destinationChain,
        dst_address: params.destinationAddress,
        dst_amount: params.destinationAmount,
        dst_token: params.destinationAsset.contract ?? '',
    };
    return {
        lock,
        destination,
        userData: dataBytes(params.nonce.toString()),
        solverData: dataBytes(params.solverData),
        amount: amount.toString(),
        assetId,
    };
}
export async function buildUserLockTx(signer, params) {
    const args = await buildUserLockArguments(signer, params);
    const contract = buildContract(params.atomicContract, signer.account);
    const scope = contract.functions
        .user_lock(args.lock, args.destination, args.userData, args.solverData)
        .callParams({ forward: [args.amount, args.assetId] });
    return scope.fundWithRequiredCoins();
}
